import React, { Component } from 'react';
import LivestreamsContainer from './LivestreamsContainer.js';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import VideosRow from './VideosRow';

class ProfileInformationContainer extends Component {
  constructor(props) {
    super(props);
    this.selectTab = this.selectTab.bind(this);

    this.state = {
      chosenTab: "Livestreams"
    }
  }

  selectTab(tab) {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "streamer_profile",
      "streamer_profile_switch_tab",
      "info",
      "https://the402.xyz",
      {
        selectedTab: tab,
      }
    );
    this.setState({
      chosenTab: tab,
    });
  }

  render() {
    return (
      <div className="min-h-[512px] mt-8 sm:mt-0 w-screen bg-custom-white dark:bg-custom-black flex">
        <div className="flex-col">
          <div className="mt-16 sm:ml-8 w-96 flex justify-around">
            <div
              onClick={() => this.selectTab("Livestreams")}
              className={
                this.state.chosenTab === "Livestreams"
                  ?
                "dark:text-white text-black text-2xl font-semibold cursor-pointer"
                  :
                "text-gray-400 dark:text-gray-500 text-2xl font-semibold cursor-pointer"
              }
            >
              Livestreams
            </div>
            {
              /*
              <div className="text-gray-400 dark:text-gray-500 text-2xl font-semibold cursor-pointer">
                About
              </div>
              */
            }
            <div
              onClick={() => this.selectTab("NFTs")}
              className={
                this.state.chosenTab === "NFTs"
                  ?
                "dark:text-white text-black text-2xl font-semibold cursor-pointer"
                  :
                "text-gray-400 dark:text-gray-500 text-2xl font-semibold cursor-pointer"
              }
            >
              NFTs
            </div>
          </div>
          {
            this.state.chosenTab === "Livestreams"
              ?
            <LivestreamsContainer
              livestreamURLs={this.props.livestreamURLs}
              livestreamURLPreviews={this.props.livestreamURLPreviews}
              shouldShowLiveStreamForPastVods={this.props.shouldShowLiveStreamForPastVods}
            />
              :
            <div className="mt-8 ml-0 sm:ml-16">
            <VideosRow
              address={this.props.account != null ? this.props.account.address : ""}
              mintedVideos={this.props.createdItems}
              setTransactionStatus={this.props.setTransactionStatus}
              selectItemForSubscribe={this.props.selectItemForSubscribe}
              subscriberStatuses={this.props.subscriberStatuses}
            />
            </div>
          }
        </div>
      </div>
    );
  }
}

export default ProfileInformationContainer;
